export interface RequirementsAndActivityFormValues {
  requirementType?: string;
  fromProcessDate: string | Date;
  toProcessDate: string | Date;
}

export enum RequirementTypes {
  Null = "",
  Cash = "CASH",
  RegT = "REG_T",
  DayTrades = "DAY_TRADE",
}
